import * as GoalpilotGenericStores from './config.js'

// TODO: move to global api
/*
export function getGlobalSubscriptionList() {
  let subscriptionList = {}
  Object.keys( GoalpilotGenericStores ).map(store_key => {
    // TODO: maybe return sync state instead of unsubscribe calback
    subscriptionList[ store_key ] = GoalpilotGenericStores[ store_key ].subscriptions || null
  })
  return subscriptionList
}
*/

// if ( process.env.NODE_ENV !== "CLI" ) {
// NEEDED FOR CF API
for ( let storeName in GoalpilotGenericStores ) {
  GoalpilotGenericStores[ storeName ].setName( storeName )
}
// }

// TODO: implement HMR here for models

export default GoalpilotGenericStores;
